export function floorToCents(value) {
  const numericValue = Number(value)
  if (!Number.isFinite(numericValue)) return 0
  return Math.floor((numericValue + Number.EPSILON) * 100) / 100
}

export function formatFlooredUsd(value) {
  return floorToCents(value).toFixed(2)
}
